import React from 'react';

const sizeData = [
  { size: 'XS', bust: '32"', waist: '24"', hip: '34"', length: '54"' },
  { size: 'S', bust: '34"', waist: '26"', hip: '36"', length: '54.5"' },
  { size: 'M', bust: '36"', waist: '28"', hip: '38"', length: '55"' },
  { size: 'L', bust: '38"', waist: '30"', hip: '40"', length: '55.5"' },
  { size: 'XL', bust: '40"', waist: '32"', hip: '42"', length: '56"' },
  { size: 'XXL', bust: '42"', waist: '34"', hip: '44"', length: '56.5"' },
];

const SizeChartModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 relative animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-pink-600 text-2xl font-bold focus:outline-none"
          aria-label="Close size chart"
        >
          ×
        </button>
        <h2 className="text-2xl font-bold text-pink-600 mb-4 text-center">Universal Size Chart</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full text-center border border-gray-200 rounded-lg">
            <thead className="bg-pink-50">
              <tr>
                <th className="py-2 px-3 border-b">Size</th>
                <th className="py-2 px-3 border-b">Bust</th>
                <th className="py-2 px-3 border-b">Waist</th>
                <th className="py-2 px-3 border-b">Hip</th>
                <th className="py-2 px-3 border-b">Length</th>
              </tr>
            </thead>
            <tbody>
              {sizeData.map((row) => (
                <tr key={row.size} className="even:bg-gray-50">
                  <td className="py-2 px-3 font-semibold text-gray-700">{row.size}</td>
                  <td className="py-2 px-3">{row.bust}</td>
                  <td className="py-2 px-3">{row.waist}</td>
                  <td className="py-2 px-3">{row.hip}</td>
                  <td className="py-2 px-3">{row.length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SizeChartModal; 